import type { PropsWithChildren } from 'react';

import { Container } from '~shared/ui/layout';

export const OrdersLayout = ({
  title,
  children,
}: { title: React.ReactNode } & PropsWithChildren) => {
  return (
    <Container>
      <div className="box-border min-h-full w-full pb-16 pt-10">
        {typeof title === 'string' ? (
          <h2 className="mb-10 mt-0 text-4xl font-bold">{title}</h2>
        ) : (
          title
        )}
        <div className="rounded-2xl bg-white p-8">{children}</div>
      </div>
    </Container>
  );
};
